import { useNavigate } from "react-router-dom";
import { ApiService as api } from "../services/ApiService";
import { useSession } from "./useSession";
import { useStates } from "./useStates";
import urls from "../config/urls.json";
import { useState } from "react";
import { isProd } from "../services/env";

export const useAppointmentResponse = () => {
    const navigate = useNavigate();
    const { batchUpdate, isAppointmentPayloadReady, getAppointmentNewPayload } = useSession();
    const { states, setCurrentState, isCreaAppuntamentoBusy, isCreaAppuntamentoError, isCreaAppuntamentoDone } = useStates();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    const showAppError = () => {
        if (!isProd()) console.log("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova");
        const errorNode = document.createElement("div");
        errorNode.classList.add("text-center");
        errorNode.style.marginTop = "300px";
        errorNode.style.marginBottom = "200px";
        errorNode.innerHTML = "C'è stato un errore con il tuo appuntamento.";
        const overlay = document.querySelector("#start-overlay");
        if (overlay) {
            overlay.replaceWith(errorNode);
        }
    };

    const handleAppointmentSubmission = async () => {
        if (!isAppointmentPayloadReady()) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_START);
        let appuntamentoResult = {};
        try {
            appuntamentoResult = await api.CreateAppointment(getAppointmentNewPayload());
        } catch (error) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);
            showAppError();
            return;
        }

        // @todo gestione errore crea
        if (!appuntamentoResult || appuntamentoResult.result === false || appuntamentoResult.resultCode == 2) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage(appuntamentoResult.message || "C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);
            showAppError();
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_END);

        batchUpdate({
            prenotazioneExists: appuntamentoResult.prenotazioneExists,
        });

        if (appuntamentoResult.typUrl) {
            window.open(appuntamentoResult.typUrl, "_self");
        } else {
            navigate(urls.riepilogo.path, { replace: true });
        }
    };

    return {
        handleAppointmentSubmission,
        isCreaAppuntamentoBusy,
        isCreaAppuntamentoError,
        isCreaAppuntamentoDone,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        setFetchErrorMessage,
    };
};
